<template>
  <div>
    <div class="modal fade" id="addDelegacjaModal" ref="modalEle" tabindex="-1">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Karty debetowe</h5>
            <button type="button" class="close ms-auto" data-bs-dismiss="modal">
              <span>&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <h6 class="mb-0">Lista kart debetowych</h6>
              <button class="btn btn-sm btn-success" @click="addKarta"><i class="bi bi-plus-lg me-1"></i> Dodaj
                kartę</button>
            </div>
            <div class="custom-table">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Karta debetowa</th>
                    <th>Użyta</th>
                    <th>Akcje</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="addingNew">
                    <td>Nowa</td>
                    <td><input v-model="newKarta.name" class="form-control" /></td>
                    <td></td>
                    <td>
                      <button @click="saveNewKarta" class="btn btn-sm btn-success me-1"><i
                          class="bi bi-save me-2"></i>Zapisz
                      </button>
                      <button @click="cancelNewKarta" class="btn btn-sm btn-danger"><i
                          class="bi bi-x-circle me-2"></i>Anuluj
                      </button>
                    </td>
                  </tr>
                  <tr v-for="(karta, index) in karty" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>
                      <input v-if="editingId === karta.id" v-model="karta.name" class="form-control" />
                      <span v-else>{{ karta.name }}</span>
                    </td>
                    <td>{{ karta.delegacje_count }}</td>
                    <td>
                      <button v-if="editingId === karta.id" @click="updateKarta(karta)"
                        class="btn btn-sm btn-success me-2">
                        Zapisz
                      </button>
                      <button v-else @click="editKarta(karta.id)" class="btn btn-sm btn-outline-info me-2"><i
                          class="bi bi-pencil me-2"></i>Edytuj
                      </button>
                      <button v-if="karta.delegacje_count === 0" @click="deleteKarta(karta.id)"
                        class="btn btn-sm btn-danger">
                        <i class="bi bi-trash me-2"></i>Usuń
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>


          <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Zamknij</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { Modal } from 'bootstrap';

export default {
  props: {
    karty: { type: Array, default: () => [] },
  },

  data() {
    return {
      modalObj: null,
      editingId: null,
      addingNew: false,
      newKarta: this.getEmptyForm()
    };
  },

  mounted() {
    this.modalObj = new Modal(this.$refs.modalEle);
  },

  methods: {
    resetForm() {
      this.editingId = null;
      this.addingNew = false;
      this.newKarta = this.getEmptyForm();
    },
    getEmptyForm() {
      return {
        id: null,
        name: ''
      };
    },

    addKarta() {
      this.addingNew = true;
      this.newKarta = this.getEmptyForm();
    },

    cancelNewKarta() {
      this.addingNew = false;
      this.newKarta = this.getEmptyForm();
    },

    editKarta(id) {
      this.editingId = id;
    },

    updateKarta(karta) {
      this.$emit("update-karta", { ...karta });
      this.resetForm();
      this.hide();
    },

    saveNewKarta() {
      if (!this.newKarta) {
        this.errorMsg("Karta musi posiadać nazwę.");
        return;
      }
      this.$emit("save-karta", this.newKarta);
      this.resetForm();
      this.hide();
    },

    deleteKarta(id) {
      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Usuwanie karty',
        html: 'Czy na pewno chcesz usunąć wybraną kartę?',
        showDenyButton: true,
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        denyButtonText: 'Nie',
        timer: false,
        position: 'center'
      }).then((result) => {
        if (result.isConfirmed) {

          this.$emit("delete-karta", id);
          this.resetForm();
          this.hide();

        }

      });
    },

    show() {
      this.modalObj.show();
    },
    errorMsg(resp) {
      Toast.fire({
        position: 'top-end',
        toast: true,
        icon: 'warning',
        title: 'Błąd!',
        html: resp,
        showClass: { popup: 'animate__animated animate__fadeInDown' },
        hideClass: { popup: 'animate__animated animate__fadeOutUp' },
        timer: 2500,
        timerProgressBar: true,
        showConfirmButton: false,
        showCloseButton: true
      });
    },


    hide() {
      this.resetForm();

      if (this.modalObj) {
        this.modalObj.hide();
      }
    }
  }
};
</script>

<style>
.position-absolute {
  background: white;
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #ddd;
}
</style>